"use client";
import React from "react";
import SkaiciuoklesPuslapisComponent from "./components/SkaiciuoklesPuslapisComponent";
import AdBanner from './components/ads/AdBanner';

type AppProps = {
  initialYear?: string;
};

function App({ initialYear }: AppProps) {
  return (
    <>
      <SkaiciuoklesPuslapisComponent initialYear={initialYear} />
      <AdBanner />
    </>
  );
}

export default App;
